import { ListaPlano, ListaResumo, ListaTemplateResumo, PixKeyResponse } from 'types';
import api from './api';

export interface CriarListaPayload {
  tituloLista: string;
  publica: boolean;
  tipoLista?: string;
  slug?: string;
  templateSlug?: string;
  dataEvento?: string;
  babyShowerSubtype?: 'boy' | 'girl' | 'unknown';
}

export interface AtualizarListaPayload {
  tituloLista?: string;
  dataEvento?: string | null;
  templateSlug?: string;
  tipoLista?: string;
  publica?: boolean;
  enableRsvp?: boolean;
  enableSaveTheDate?: boolean;
  rsvpEventDate?: string | null;
  saveDateEventDate?: string | null;
  saveDateEventTime?: string | null;
  saveDateLocation?: string | null;
  saveDateHeadline?: string | null;
  saveDateDescription?: string | null;
}

export interface VerificarSlugResponse {
  disponivel: boolean;
  slug: string;
  sugestao?: string;
}

export interface ConfirmacaoPresencaAdmin {
  id: string;
  nome: string;
  createdAt: string;
}

export interface ConfirmacoesPresencaAdminResponse {
  total: number;
  confirmacoes: ConfirmacaoPresencaAdmin[];
}

export const listarMinhasListas = async (): Promise<ListaResumo[]> => {
  const response = await api.get<{ listas: ListaResumo[] }>('/listas/minhas');
  return response.data.listas ?? [];
};

export const listarTemplates = async (): Promise<ListaTemplateResumo[]> => {
  const response = await api.get<{ templates: ListaTemplateResumo[] }>('/listas/templates');
  return response.data.templates ?? [];
};

export const criarLista = async (payload: CriarListaPayload) => {
  const response = await api.post('/listas', payload);
  return response.data;
};

export const atualizarLista = async (listaId: string, payload: AtualizarListaPayload) => {
  const response = await api.put(`/listas/${listaId}`, payload);
  return response.data;
};

export const verificarSlugDisponivel = async (slug: string): Promise<VerificarSlugResponse> => {
  const response = await api.get<VerificarSlugResponse>(
    `/listas/slug/${encodeURIComponent(slug)}/disponibilidade`
  );
  return response.data;
};

export const obterPixKeys = async (listaId: string): Promise<PixKeyResponse> => {
  const response = await api.get<PixKeyResponse>(`/listas/${listaId}/pix-keys`);
  return response.data;
};

export const salvarPixKey = async (listaId: string, chavePix: string): Promise<PixKeyResponse> => {
  const response = await api.post<PixKeyResponse>(`/listas/${listaId}/pix-keys`, { chavePix });
  return response.data;
};

export const listarConfirmacoesPresencaAdmin = async (
  listaId: string
): Promise<ConfirmacoesPresencaAdminResponse> => {
  const response = await api.get<ConfirmacoesPresencaAdminResponse>(`/listas/${listaId}/presenca`);
  return response.data;
};

export const atualizarPlano = async (listaId: string, plano: ListaPlano) => {
  const response = await api.put(`/listas/${listaId}`, { plano });
  return response.data;
};

export const encerrarLista = async (listaId: string) => {
  const response = await api.delete(`/listas/${listaId}`);
  return response.data;
};

export interface TrocarTemplateResponse {
  success: boolean;
  templateSlug: string;
  sugestoes: Array<{
    nome: string;
    descricao?: string;
    valor: number;
    categoria?: string;
    imagemUrl?: string;
  }>;
}

export const trocarTemplateLista = async (
  listaId: string,
  templateSlug: string
): Promise<TrocarTemplateResponse> => {
  const response = await api.patch<TrocarTemplateResponse>(`/listas/${listaId}/template`, {
    templateSlug,
  });
  return response.data;
};
